import { Pipe, PipeTransform } from '@angular/core';

import { injectMailgunBlockDepth } from '../mailgun/tokens';
import { WrappedValue, wrapValue } from '../mailgun/wrap-value';

@Pipe({
  standalone: true,
  name: 'mailgunRelativePath',
})
export class MailgunRelativePathPipe implements PipeTransform {
  public depth = injectMailgunBlockDepth();
  public transform(value: WrappedValue<any>): any {
    const rel = `../`.repeat(this.depth);
    return wrapValue(`${rel}${value.toPath()}`, value.toValue(), value.getOpts());
  }
}
